<template>
  <div class="user-info">
    <img :src="info.userpic" class="head-img" />
    <div class="user-name">{{info.nickname}}</div>
    <div class="user-phone">{{info.phone}}</div>
    <!-- 注销 -->
    <img :src="IconSetup" class="logout-icon" @click="Logout" />
    <!-- 交易记录 -->
    <div class="history" @click="$nav('Common.Transaction')">
      <span>交易记录</span>
      <img :src="IconRight" class="right-icon" />
    </div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    methods: {
      Logout () {
        this.$ShowConfirm('请问您是否要退出登录呢？').then(() => {
          this.$Post('Common.logout').then(res => {
            this.$nav('Common.Login')
          })
        })
      }
    },
    computed: {
      ...SetImage(['IconSetup', 'IconRight'])
    },
    props: {
      info: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="less" scoped>
  .user-info {
    .br(.1rem);
    position: relative;
    z-index: 10;
    .bg(#fff);
    .p(.3rem 0);
    .flex-ccc();
    .mb(.3rem);
    box-shadow: 0rem 0.02rem 0.29rem 0.01rem rgba(0, 0, 0, 0.06);
    .head-img {
      .w(1.1rem);
      .h(1.1rem);
      .br(.55rem);
      .mb(.2rem);
    }
    .user-name {
      .fz(.36rem);
      .c(#333);
      font-weight: bold;
      .mb(.12rem);
    }
    .user-phone {
      .fz(.26rem);
      .c(#999);
    }
    .logout-icon {
      .w(.32rem);
      position: absolute;
      top: .3rem;
      right: .24rem;
    }
    .history {
      .fz(.26rem);
      .c(#388bff);
      position: absolute;
      bottom: .25rem;
      right: .25rem;
      display: flex;
      align-items: center;
      .right-icon {
        .w(.12rem);
        .h(.2rem);
        .ml(.08rem);
      }
    }
  }
</style>
